/**
 * Game configuration constants
 */
export const GAME_CONFIG = {
  // Canvas dimensions
  width: 800,
  height: 600,
  backgroundColor: '#0a0a0f',

  // Player settings
  player: {
    speed: 300,
    fireRate: 250, // ms between shots
    lives: 3,
    respawnDelay: 1500, // ms
    invulnerabilityDuration: 2000, // ms
  },

  // Alien grid settings
  aliens: {
    rows: 5,
    cols: 11,
    startX: 150,
    startY: 80,
    spacingX: 50,
    spacingY: 45,
    baseSpeed: 20,        // Reduced from 30 for gentler wave 1 start
    speedIncrement: 5,    // per alien destroyed
    dropDistance: 20,
    baseFireRate: 2500,   // Increased from 2000 for more forgiving wave 1
    fireRateDecrease: 80, // Reduced from 100 for slower fire rate escalation
    minFireRate: 500,     // Raised from 400 to prevent overwhelming bullet spam
  },

  // Scoring
  scoring: {
    alienPoints: {
      top: 40,     // Magenta aliens (row 1)
      middle: 20,  // Green aliens (rows 2-3)
      bottom: 10,  // Yellow aliens (rows 4-5)
    },
    ufoMinPoints: 50,
    ufoMaxPoints: 300,
    comboTimeout: 2000, // ms to maintain combo
    comboMultiplierMax: 5,
  },

  // Mystery UFO settings
  ufo: {
    speed: 150,
    minSpawnInterval: 15000, // ms
    maxSpawnInterval: 30000, // ms
  },

  // Shield settings
  shields: {
    count: 4,
    startY: 470,
  },

  // Progressive difficulty
  waves: {
    speedMultiplier: 1.08, // per wave (reduced from 1.15 for gentler wave-over-wave escalation)
    fireRateMultiplier: 0.9, // per wave (lower = faster)
  },

  // Colors (neon palette)
  colors: {
    background: 0x0a0a0f,
    player: 0x00ffff,       // Cyan
    alienTop: 0xff00ff,     // Magenta
    alienMiddle: 0x00ff41,  // Green
    alienBottom: 0xffff00,  // Yellow
    projectile: 0xffffff,   // White
    shield: 0x00cc88,       // Blue-green
    ufo: 0xff3333,          // Red
    hud: 0x00ffff,          // Cyan
    textGlow: 0x00ffff,     // Cyan
  },
};
